import { useEffect, useRef, useState } from "react";

export const useDebounce = (value: string, delay = 400) => {
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
  const [debouncevalue, SetDebounceValue] = useState<any>(value);
  useEffect(() => {
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(() => {
      SetDebounceValue(value);
    }, delay);

    return () => {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    };
  }, [value, delay]);

  return debouncevalue;
};
